export const OAUTH_CLIENT_ID = import.meta.env.VITE_APP_GOOGLE_OAUTH_CLIENT_ID;
const LEGACY_API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;
export const API_HOST = (
  import.meta.env.VITE_APP_API_HOST ||
  (LEGACY_API_BASE_URL ? new URL(LEGACY_API_BASE_URL).origin : "")
).replace(/\/$/, "");
export let API_BASE_URL = LEGACY_API_BASE_URL;
export const UPLOAD_API_BASE_URL = import.meta.env.VITE_APP_UPLOAD_API_BASE_URL;
export const EMPTY_OBJECT = Object.freeze({});
export const EMPTY_ARRAY = Object.freeze([]);
export let IS_WHITE_LABEL = import.meta.env.VITE_APP_IS_WHITE_LABEL === "true";
export const DISABLE_UPLOAD = import.meta.env.VITE_APP_DISABLE_UPLOAD === "true";
export const ORG_BASE_URL =
  import.meta.env.VITE_APP_ORG_BASE_URL ||
  `${API_HOST}/c/org/${import.meta.env.VITE_APP_ORG_SHORT_ID}`;

export function configureOrganization({ id, config }: { id: number; config?: { whiteLabel?: boolean } }) {
  API_BASE_URL = `${API_HOST}/c/org/${id}/`;
  if (typeof config?.whiteLabel === "boolean") IS_WHITE_LABEL = config.whiteLabel;
}
